import { Project } from "../../../../types/project/project";
import { Resume } from "../../../../types/resume/resume";

export function generateEnglishResume(projects: Project[] | undefined): Resume {
  const resume: Resume = {
    name: "Colby Birkhead",
    title: "Full Stack Web Developer",
    contact: {
      phone: '+82-10-6501-5021',
      email: 'birkheadc@gmail.com',
      websites: [
        {
          name: 'birkheadc.me',
          url: 'https://birkheadc.me'
        },
        {
          name: 'linkedin.com/in/colby-birkhead',
          url: 'https://linkedin.com/in/colby-birkhead'
        },
        {
          name: 'github.com/birkheadc',
          url: 'https://github.com/birkheadc'
        },
        {
          name: 'facebook.com/colby.birkhead',
          url: 'https://facebook.com/colby.birkhead'
        }
      ]
    },
    introduction: 'Full stack software developer and startup CTO with professional experience spanning SEO, business dashboards, and internal tooling. As CTO, oversaw long-term roadmaps spanning both legacy application overhauls and brand new development. Comfortable owning a project end-to-end, from architecture through cloud deployment. Skilled at adapting to new environments and leading teams through change. American expat fully fluent in English and Japanese, conversationally fluent in Korean.',
    sections: [
      {
        name: 'career',
        items: [
          {
            date: {
              from: 'Spring 2025',
            },
            title: "CTO",
            bulletPoints: [
              "Oversee application development and manage technical resources for the company",
              "Oversaw the creation and completion of an 8-month roadmap to overhaul internal tooling, automating an estimated 73.7% of relevant tasks for the management team",
              "Pioneered AI-first workflows across the full development lifecycle, spanning design, prototyping, demos, implementation, and testing",
            ]
          },
          {
            date: {
              from: 'Spring 2024',
              to: 'Spring 2025'
            },
            title: "Software Developer",
            bulletPoints: [
              "Developed dashboard application for managing online presence of small businesses",
              "Worked extensively with multiple third-party APIs including Google and Instagram",
              "Updated an ETL data pipeline processing millions of records, with zero disruption to service",
            ]
          },
          {
            date: {
              from: 'Spring 2017',
              to: 'Spring 2024'
            },
            title: 'Retail Manager',
            bulletPoints: [
              "Managed a grocery store focused on foreign clientele",
              "Developed applications on the side to assist with daily duties, including a book-keeping application that now automates what used to be over 100 hours of work a year"
            ]
          }
        ]
      },
      {
        name: 'education',
        items: [
          {
            date: {
              from: 'Spring 2013',
              to: 'Spring 2017'
            },
            title: 'Nagoya University, Aichi Japan',
            bulletPoints: [
              "Bachelor's of Arts in Linguistics / Full-ride MEXT scholarship student",
            ]
          }
        ]
      },
      {
        name: 'personal projects',
        items: projects ? projects.sort((a, b) => b.resumeFavoriteLevel - a.resumeFavoriteLevel).slice(0, 2).map(
          project =>
          ({
            title: project.title,
            bulletPoints: project.descriptions.bulletPoints.find(bp => bp.language === 'en')?.content ?? [],
            site: project.site,
            source: project.source
          })
        ) : []
      },
      {
        name: 'skills',
        items: [
          {
            title: "Full Stack Web Development",
            bulletPoints: [
              "Core stack: modern TypeScript, React, Node, NestJS, PostgreSQL, cloud deployment (AWS)",
              "Also experienced with: HTML5, CSS, Angular, C# / ASP.NET, Java / Spring, Ruby / Rails, MySQL, SQLite, MongoDB, DynamoDB",
              "Comfortable with many peripheral technologies and services: Linux, Bash, Git, Docker"
            ]
          },
          {
            title: "Game Development",
            bulletPoints: [
              "Participated in and published to multiple online game jams.",
            ]
          },
          {
            title: "Human Languages",
            bulletPoints: [
              "15+ years Japanese, fully fluent",
              "5+ years Korean, conversationally fluent"
            ]
          }
        ]
      }
    ]
  }

  return resume;
}